/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
export type AlcoholConsumption = (typeof AlcoholConsumption)[keyof typeof AlcoholConsumption];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlcoholConsumption = {
  never: 'never',
  monthlyOrLess: 'monthlyOrLess',
  monthly: 'monthly',
  weekly: 'weekly',
  daily: 'daily',
} as const;

export interface AllergyModel {
  observationKey: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  onset?: Date | null;
  /** @nullable */
  doseSpotAllergenId?: number | null;
  /** @nullable */
  doseSpotAllergyId?: number | null;
}

export type AnswerType = (typeof AnswerType)[keyof typeof AnswerType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnswerType = {
  radio: 'radio',
  checkboxOther: 'checkboxOther',
  datePast: 'datePast',
  datePastWithOption: 'datePastWithOption',
  slider10: 'slider10',
  textLong: 'textLong',
  textShort: 'textShort',
  yesNo: 'yesNo',
  photoUpload: 'photoUpload',
  dropdown: 'dropdown',
  bodyLocation: 'bodyLocation',
  file: 'file',
} as const;

export interface ApiClientLoginErrorResponse {
  type: ApiClientLoginErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type ApiClientLoginErrorType =
  (typeof ApiClientLoginErrorType)[keyof typeof ApiClientLoginErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiClientLoginErrorType = {
  InvalidRequest: 'InvalidRequest',
  InvalidClientCredentials: 'InvalidClientCredentials',
  MigrationFailed: 'MigrationFailed',
} as const;

export interface ApiClientLoginSuccessResponse {
  access_token: string;
  expires_in: number;
  token_type: string;
}

export interface ApplyPromoCodeErrorResponse {
  type: ApplyPromoCodeErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type ApplyPromoCodeErrorType =
  (typeof ApplyPromoCodeErrorType)[keyof typeof ApplyPromoCodeErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplyPromoCodeErrorType = {
  ValidationFailed: 'ValidationFailed',
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
} as const;

export interface ApplyPromoCodeRequest {
  promoCode: string;
}

export interface AvailableTfaMethod {
  method: TwoFactorMethod;
  destination: string;
}

export interface BirthDateMismatch {
  idBirthDate: string;
  submittedBirthDate: string;
}

export type BodyLocationType = (typeof BodyLocationType)[keyof typeof BodyLocationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BodyLocationType = {
  head: 'head',
  chest: 'chest',
  back: 'back',
  arm: 'arm',
  leg: 'leg',
  armpit: 'armpit',
  other: 'other',
} as const;

export interface CancelEncounterErrorResponse {
  type: CancelEncounterErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type CancelEncounterErrorType =
  (typeof CancelEncounterErrorType)[keyof typeof CancelEncounterErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancelEncounterErrorType = {
  NotFound: 'NotFound',
  ValidationFailed: 'ValidationFailed',
} as const;

/**
 * @nullable
 */
export type CancelEncounterRequestCancelReason = CancellationReason | null;

export interface CancelEncounterRequest {
  /** @nullable */
  cancelReason?: CancelEncounterRequestCancelReason;
  /** @nullable */
  cancelFeedback?: string | null;
}

export interface CancelEncounterResponse {
  encounterId: number;
}

export type CancellationReason = (typeof CancellationReason)[keyof typeof CancellationReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationReason = {
  reasonWaitTime: 'reasonWaitTime',
  reasonInPerson: 'reasonInPerson',
  reasonExpense: 'reasonExpense',
  reasonNoInsurance: 'reasonNoInsurance',
  reasonAppIssues: 'reasonAppIssues',
  reasonCCDenied: 'reasonCCDenied',
  reasonIdentityVerification: 'reasonIdentityVerification',
  reasonOther: 'reasonOther',
} as const;

export interface CancellationReasonResponse {
  id: CancellationReason;
  description: string;
}

export interface CheckUsernameErrorResponse {
  type: CheckUsernameErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type CheckUsernameErrorType =
  (typeof CheckUsernameErrorType)[keyof typeof CheckUsernameErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CheckUsernameErrorType = {
  ValidationFailed: 'ValidationFailed',
} as const;

export interface CheckUsernameRequest {
  username: string;
}

export interface CheckUsernameResponse {
  available: boolean;
}

export interface ConvergeAddress {
  /** @nullable */
  line1?: string | null;
  /** @nullable */
  line2?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  state?: string | null;
  /** @nullable */
  zip?: string | null;
}

/**
 * @nullable
 */
export type ConvergeCareGiverAddress = ConvergeAddress | null;

/**
 * @nullable
 */
export type ConvergeCareGiverPhone = ConvergePhone | null;

export interface ConvergeCareGiver {
  /** @nullable */
  first_name?: string | null;
  /** @nullable */
  last_name?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  address?: ConvergeCareGiverAddress;
  /** @nullable */
  phone?: ConvergeCareGiverPhone;
  /** @nullable */
  birth_date?: string | null;
  /** @nullable */
  gender?: string | null;
}

export interface ConvergePhone {
  /** @nullable */
  type?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface CounselingModel {
  /** @nullable */
  whoGets?: string | null;
  /** @nullable */
  whatCauses?: string | null;
  /** @nullable */
  usualCourse?: string | null;
  /** @nullable */
  makesWorse?: string | null;
  additionalAdvices: string[];
}

export interface CreateAllergyParams {
  externalId: string;
  text: string;
}

export interface CreateConvergePatientErrorResponse {
  type: CreateConvergePatientErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type CreateConvergePatientErrorType =
  (typeof CreateConvergePatientErrorType)[keyof typeof CreateConvergePatientErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateConvergePatientErrorType = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;

export interface CreateConvergePatientSuccessResponse {
  redirect_url: string;
}

export interface CreateEncounterErrorResponse {
  type: CreateEncounterErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type CreateEncounterErrorType =
  (typeof CreateEncounterErrorType)[keyof typeof CreateEncounterErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateEncounterErrorType = {
  Forbidden: 'Forbidden',
  EncounterAlreadyExists: 'EncounterAlreadyExists',
  ValidationFailed: 'ValidationFailed',
  StateNotAvailable: 'StateNotAvailable',
} as const;

export interface CreateEncounterRequest {
  networkId: number;
  /** @nullable */
  receiveCareState?: string | null;
  /** @nullable */
  referredProviderId?: string | null;
}

export interface CreateEncounterResponse {
  encounterId: number;
  /** @nullable */
  price?: number | null;
}

export interface CreateFileErrorResponse {
  type: CreateFileErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type CreateFileErrorType = (typeof CreateFileErrorType)[keyof typeof CreateFileErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateFileErrorType = {
  ValidationFailed: 'ValidationFailed',
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  TooManyDocuments: 'TooManyDocuments',
} as const;

export interface CreateFileResponse {
  fileId: number;
}

export interface CreateHostedPciPaymentErrorResponse {
  type: CreateHostedPciPaymentErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
  /** @nullable */
  responseStatus?: string | null;
  /** @nullable */
  responseStatusCode?: string | null;
  /** @nullable */
  responseStatusDescription?: string | null;
  /** @nullable */
  responseStatusReasonCode?: string | null;
}

export type CreateHostedPciPaymentErrorType =
  (typeof CreateHostedPciPaymentErrorType)[keyof typeof CreateHostedPciPaymentErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateHostedPciPaymentErrorType = {
  ValidationFailed: 'ValidationFailed',
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  PaymentFailed: 'PaymentFailed',
  InvalidVisitStatus: 'InvalidVisitStatus',
  AlreadySubmitted: 'AlreadySubmitted',
} as const;

export interface CreateHostedPciPaymentRequest {
  readonly isFreeVisit: boolean;
}

export interface CreateHostedPciPaymentResponse {
  amountPaid: number;
  isVideoCallRequired: boolean;
}

export interface CreateIdentityVerificationErrorResponse {
  type: CreateIdentityVerificationErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type CreateIdentityVerificationErrorType =
  (typeof CreateIdentityVerificationErrorType)[keyof typeof CreateIdentityVerificationErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateIdentityVerificationErrorType = {
  ValidationFailed: 'ValidationFailed',
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
} as const;

export interface CreateIdentityVerificationRequest {
  jobId: string;
  isVerified: boolean;
  type: IdentityVerificationType;
}

export interface CreateIdentityVerificationResponse {
  jobId: string;
  type: IdentityVerificationType;
}

/**
 * @nullable
 */
export type CreateIllnessParamsType = IllnessType | null;

export interface CreateIllnessParams {
  /** @nullable */
  type?: CreateIllnessParamsType;
  text: string;
}

export interface CreateImageErrorResponse {
  type: CreateImageErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type CreateImageErrorType = (typeof CreateImageErrorType)[keyof typeof CreateImageErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateImageErrorType = {
  ValidationFailed: 'ValidationFailed',
  InvalidImage: 'InvalidImage',
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  TooManyImages: 'TooManyImages',
} as const;

export interface CreateImageResponse {
  id: number;
  imageSrc: string;
}

export interface CreateManualRequestErrorResponse {
  type: CreateManualRequestErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type CreateManualRequestErrorType =
  (typeof CreateManualRequestErrorType)[keyof typeof CreateManualRequestErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateManualRequestErrorType = {
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface CreateManualRequestResponse {
  jobId: string;
}

/**
 * @nullable
 */
export type CreateMedicalIntakeFemaleQuestion = FemaleQuestion | null;

export interface CreateMedicalIntake {
  skinType: SkinType;
  skinTone: SkinTone;
  heightFeet: number;
  heightInches: number;
  weight: number;
  alcoholConsumption: AlcoholConsumption;
  tobaccoConsumption: TobaccoConsumption;
  sunbathFrequency: Frequencies;
  timeOutdoorsFrequency: Frequencies;
  occupation: string;
  visitGender: Gender;
  /** @nullable */
  visitGenderOther?: string | null;
  uterus: boolean;
  /** @nullable */
  femaleQuestion?: CreateMedicalIntakeFemaleQuestion;
  /** @nullable */
  dueDate?: string | null;
}

export interface CreateMedicationParams {
  externalId: string;
  text: string;
}

export interface CreateMessageErrorResponse {
  type: CreateMessageErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type CreateMessageErrorType =
  (typeof CreateMessageErrorType)[keyof typeof CreateMessageErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateMessageErrorType = {
  ValidationFailed: 'ValidationFailed',
  InvalidImage: 'InvalidImage',
  MaxPhotoLimit: 'MaxPhotoLimit',
  Forbidden: 'Forbidden',
  NotFound: 'NotFound',
} as const;

export interface CreateMessageResponse {
  id: number;
  /** @nullable */
  messageText?: string | null;
  fileNames: string[];
}

/**
 * @nullable
 */
export type CreatePaymentErrorResponseErrorCode = PaymentErrorCodes | null;

export interface CreatePaymentErrorResponse {
  type: CreatePaymentErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
  /** @nullable */
  errorCode?: CreatePaymentErrorResponseErrorCode;
}

export type CreatePaymentErrorType =
  (typeof CreatePaymentErrorType)[keyof typeof CreatePaymentErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePaymentErrorType = {
  ValidationFailed: 'ValidationFailed',
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  PaymentFailed: 'PaymentFailed',
  PaymentServerError: 'PaymentServerError',
  PromoCodeInvalid: 'PromoCodeInvalid',
  PromoCodeNotEnabled: 'PromoCodeNotEnabled',
  AlreadySubmitted: 'AlreadySubmitted',
  InvalidVisitStatus: 'InvalidVisitStatus',
} as const;

export interface CreatePaymentRequest {
  readonly isFreeVisit: boolean;
}

export interface CreatePaymentResponse {
  amountPaid: number;
  isVideoCallRequired: boolean;
}

export interface CreateSessionResponse {
  /** @nullable */
  redirectUrl?: string | null;
}

export interface CreateSmsTfaOptionErrorResponse {
  type: CreateSmsTfaOptionErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type CreateSmsTfaOptionErrorType =
  (typeof CreateSmsTfaOptionErrorType)[keyof typeof CreateSmsTfaOptionErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSmsTfaOptionErrorType = {
  ValidationFailed: 'ValidationFailed',
  Unauthorized: 'Unauthorized',
  AlreadyConfigured: 'AlreadyConfigured',
  InvalidPhoneNumber: 'InvalidPhoneNumber',
  UpdateFailed: 'UpdateFailed',
} as const;

export interface CreateSmsTfaOptionRequest {
  phoneNumber: string;
}

export interface CreateSmsTfaOptionResponse {
  phoneNumber: string;
}

export interface CreateSupportCaseErrorResponse {
  type: CreateSupportCaseErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type CreateSupportCaseErrorType =
  (typeof CreateSupportCaseErrorType)[keyof typeof CreateSupportCaseErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSupportCaseErrorType = {
  ValidationFailed: 'ValidationFailed',
} as const;

export interface CreateSupportCaseRequest {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  issueType: SupportIssueType;
  description: string;
  /** @nullable */
  networkId?: number | null;
}

export interface CreateSupportCaseResponse {
  id: number;
}

export type DashboardStatus = (typeof DashboardStatus)[keyof typeof DashboardStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DashboardStatus = {
  Unknown: 'Unknown',
  VisitInProgress: 'VisitInProgress',
  TreatmentPlanAvailable: 'TreatmentPlanAvailable',
  ProfileIncomplete: 'ProfileIncomplete',
  UnderAgeNoSurrogate: 'UnderAgeNoSurrogate',
  ProfileCompleteNoPrevVisit: 'ProfileCompleteNoPrevVisit',
  SelectNewProvider: 'SelectNewProvider',
  PatientCanceled: 'PatientCanceled',
  AwaitingTreatmentGeneralWaitingRoom: 'AwaitingTreatmentGeneralWaitingRoom',
  AwaitingTreatmentSelectedProvider: 'AwaitingTreatmentSelectedProvider',
  AwaitingTreatmentVideoRequired: 'AwaitingTreatmentVideoRequired',
  AwaitingTreatmentLegacyVisit: 'AwaitingTreatmentLegacyVisit',
  AwaitingTreatmentVideoRequiredLegacyVisit: 'AwaitingTreatmentVideoRequiredLegacyVisit',
  VisitPausedForEdits: 'VisitPausedForEdits',
  NewPhotosNeeded: 'NewPhotosNeeded',
  NotQualifiedForCare: 'NotQualifiedForCare',
  CanceledDidNotSelectNewProvider: 'CanceledDidNotSelectNewProvider',
  CanceledDidNotResubmitAfterEdits: 'CanceledDidNotResubmitAfterEdits',
  LastCompletedVisitOutsideActivePeriod: 'LastCompletedVisitOutsideActivePeriod',
  LastCompletedVisitWithinActivePeriod: 'LastCompletedVisitWithinActivePeriod',
  DiagnosisInProgress: 'DiagnosisInProgress',
  CanceledDidNotUploadNewPhotos: 'CanceledDidNotUploadNewPhotos',
  PatientCanceledDidNotSubmit: 'PatientCanceledDidNotSubmit',
  TriagedOutByProvider: 'TriagedOutByProvider',
  TriagedOutByProviderUnreadTreatmentPlan: 'TriagedOutByProviderUnreadTreatmentPlan',
  VisitInProgressVideoMessaging: 'VisitInProgressVideoMessaging',
  IncompleteVisitCancelled: 'IncompleteVisitCancelled',
  VisitCancelledByPatient: 'VisitCancelledByPatient',
  IdentityManualReviewPending: 'IdentityManualReviewPending',
  IdentityManualReviewApproved: 'IdentityManualReviewApproved',
  IdentityManualReviewRejected: 'IdentityManualReviewRejected',
  LocationNotSupported: 'LocationNotSupported',
  MedicaidNotSupported: 'MedicaidNotSupported',
  MedicaidStateMismatch: 'MedicaidStateMismatch',
} as const;

export type DeleteFileErrorType = (typeof DeleteFileErrorType)[keyof typeof DeleteFileErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteFileErrorType = {
  ValidationFailed: 'ValidationFailed',
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
} as const;

export interface DeleteFileErrorTypeErrorResponse {
  type: DeleteFileErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export interface DeleteImageErrorResponse {
  type: DeleteImageErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type DeleteImageErrorType = (typeof DeleteImageErrorType)[keyof typeof DeleteImageErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteImageErrorType = {
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface DeletePromoCodeFromEncounterErrorResponse {
  type: DeletePromoCodeFromEncounterErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type DeletePromoCodeFromEncounterErrorType =
  (typeof DeletePromoCodeFromEncounterErrorType)[keyof typeof DeletePromoCodeFromEncounterErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeletePromoCodeFromEncounterErrorType = {
  ValidationFailed: 'ValidationFailed',
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
} as const;

export interface DeleteSmsTfaOptionErrorResponse {
  type: DeleteSmsTfaOptionErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type DeleteSmsTfaOptionErrorType =
  (typeof DeleteSmsTfaOptionErrorType)[keyof typeof DeleteSmsTfaOptionErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteSmsTfaOptionErrorType = {
  ValidationFailed: 'ValidationFailed',
  Unauthorized: 'Unauthorized',
  NotConfigured: 'NotConfigured',
  UpdateFailed: 'UpdateFailed',
} as const;

export interface DiagnosisModel {
  /** @nullable */
  whatIs?: string | null;
  /** @nullable */
  howDiagnosed?: string | null;
}

export type EncounterResolution = (typeof EncounterResolution)[keyof typeof EncounterResolution];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EncounterResolution = {
  NotCompleted: 'NotCompleted',
  Completed: 'Completed',
  PatientCancelled: 'PatientCancelled',
  ProviderInProgress: 'ProviderInProgress',
  TriageOut: 'TriageOut',
  AwaitingLegacy: 'AwaitingLegacy',
} as const;

/**
 * @nullable
 */
export type EncounterResponsePreferredPharmacyType = PharmacyType | null;

export interface EncounterResponse {
  id: number;
  statusId: number;
  state: string;
  stateRules: StateRuleDto[];
  /** @nullable */
  preferredPharmacyType?: EncounterResponsePreferredPharmacyType;
  /** @nullable */
  preferredProviderId?: string | null;
  /** @nullable */
  assignedProviderId?: string | null;
  /** @nullable */
  approvedProviderId?: string | null;
  /** @nullable */
  preferredPharmacyId?: number | null;
  isSurrogate: boolean;
  hasBeenSubmitted: boolean;
  /** @nullable */
  isVideoRequired?: boolean | null;
  isMedicaid: boolean;
  network: string;
}

export type EncounterStatus = (typeof EncounterStatus)[keyof typeof EncounterStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EncounterStatus = {
  All: 'All',
  Completed: 'Completed',
} as const;

export type EncounterStatusIdsType =
  (typeof EncounterStatusIdsType)[keyof typeof EncounterStatusIdsType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EncounterStatusIdsType = {
  PreSubmitCreateAccount: 100,
  Consent: 150,
  PreSubmitPreScreenFailed: 151,
  InsuranceInformation: 155,
  ConditionInformationPage1: 200,
  ConditionInformationPage2: 205,
  ConditionInformationPage3: 210,
  ConditionInformationPage4: 215,
  ProviderSelection: 300,
  PharmacySelection: 305,
  ClinicalInformationMedicalIntake: 400,
  ClinicalInformationMedicalHistory: 405,
  PreSubmitReview: 600,
  PreSubmitIdentityVerification: 615,
  PreSubmitPaymentInfo: 650,
  PreSubmitNoExistingRelationship: 670,
  InWaitingRoom: 700,
  AwaitingIdCheck: 710,
  ProviderInProgress: 800,
  ProviderInProgressMakingApproverChanges: 805,
  ProviderInProgressMakingChangesPriorToApproval: 806,
  WaitingResponseFromPatient: 810,
  ProviderCompleteWithErxPendingApproval: 820,
  ProviderCompleteWithErxPendingApprovalInProgress: 821,
  ProviderCompleteWithErxPendingApprovalDenied: 822,
  ProviderCompleteWithErxPendingApprovalEscalated: 825,
  ProviderCompleteWithErxPendingApprovalEscalatedInProgress: 826,
  ProviderCompleteWithErxPendingApprovalEscalatedDenied: 827,
  ProviderCompleteWithoutErxPendingApproval: 830,
  ProviderCompleteWithoutErxPendingApprovalInProgress: 831,
  ProviderCompleteWithoutErxPendingApprovalDenied: 832,
  ProviderCompleteWithoutErxPendingApprovalEscalated: 835,
  ProviderCompleteWithoutErxPendingApprovalEscalatedInProgress: 836,
  ProviderCompleteWithoutErxPendingApprovalEscalatedDenied: 837,
  ApprovalCompletePendingMidlevelVideoCall: 840,
  ApprovalCompletePendingMidlevelErxSubmission: 850,
  ProviderCompleteWithErxTreatmentPlanUnread: 900,
  ProviderCompleteWithErxTreatmentPlanRead: 901,
  ProviderCompleteWithNoErxTreatmentPlanUnread: 910,
  ProviderCompleteWithNoErxTreatmentPlanRead: 911,
  PatientCanceledIncomplete: 916,
  ProviderCompleteTriagedOutTreatmentPlanUnread: 920,
  ProviderCompleteTriagedOutTreatmentPlanRead: 921,
  PatientCancelledTreatmentPlanUnread: 930,
  PatientCancelledTreatmentPlanRead: 931,
  PatientCancelledThemselves: 940,
} as const;

export interface EncounterSummaryItem {
  id: number;
  diagnosis: string;
  /** @nullable */
  lastStatusDate?: Date | null;
  /** @nullable */
  createDate?: Date | null;
  statusId: EncounterStatusIdsType;
  state: number;
  unreadMessages: number;
  encounterResolution: EncounterResolution;
  canMessage: boolean;
  /** @nullable */
  assignedProvider?: string | null;
}

export interface EncounterWorkflowPage {
  pageId: number;
  label: string;
}

export interface Error {
  correctiveAction: string;
  reason: string;
  reasonCode: string;
  errorLevel: string;
}

export type Ethnicity = (typeof Ethnicity)[keyof typeof Ethnicity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Ethnicity = {
  CW: 'CW',
  HL: 'HL',
  AAB: 'AAB',
  A: 'A',
  AIAN: 'AIAN',
  NHOPI: 'NHOPI',
  ME: 'ME',
  NS: 'NS',
} as const;

export interface ExternalLoginOption {
  url: string;
  text: string;
  /** @nullable */
  logoUrl?: string | null;
}

export type FemaleQuestion = (typeof FemaleQuestion)[keyof typeof FemaleQuestion];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FemaleQuestion = {
  Premenarche: 'Premenarche',
  NonPregnant: 'NonPregnant',
  TryingToConceive: 'TryingToConceive',
  Pregnant: 'Pregnant',
  Nursing: 'Nursing',
  Menopause: 'Menopause',
  NotApplicable: 'NotApplicable',
} as const;

export interface FileDTO {
  id: number;
  path: string;
  description: string;
}

export type FileReasonType = (typeof FileReasonType)[keyof typeof FileReasonType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileReasonType = {
  WrongImage: 'WrongImage',
  PoorQuality: 'PoorQuality',
  SubjectTooLarge: 'SubjectTooLarge',
  SubjectTooSmall: 'SubjectTooSmall',
  Other: 'Other',
} as const;

export type FileStatus = (typeof FileStatus)[keyof typeof FileStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileStatus = {
  Good: 'Good',
  Bad: 'Bad',
  Deleted: 'Deleted',
  Replaced: 'Replaced',
} as const;

export interface ForgotPasswordErrorResponse {
  type: ForgotPasswordErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type ForgotPasswordErrorType =
  (typeof ForgotPasswordErrorType)[keyof typeof ForgotPasswordErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ForgotPasswordErrorType = {
  ValidationFailed: 'ValidationFailed',
  UserNotFound: 'UserNotFound',
  NetworkNotFound: 'NetworkNotFound',
  MigrationFailed: 'MigrationFailed',
} as const;

export interface ForgotPasswordRequest {
  username: string;
  networkId: number;
}

export type Frequencies = (typeof Frequencies)[keyof typeof Frequencies];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Frequencies = {
  never: 'never',
  occasional: 'occasional',
  seasonally: 'seasonally',
  frequently: 'frequently',
  daily: 'daily',
} as const;

export type Gender = (typeof Gender)[keyof typeof Gender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Gender = {
  female: 'female',
  male: 'male',
  other: 'other',
} as const;

export interface GenerateReceiptPdfErrorResponse {
  type: GenerateReceiptPdfErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GenerateReceiptPdfErrorType =
  (typeof GenerateReceiptPdfErrorType)[keyof typeof GenerateReceiptPdfErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateReceiptPdfErrorType = {
  NotFound: 'NotFound',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface GenerateReferralLetterPdfErrorResponse {
  type: GenerateReferralLetterPdfErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GenerateReferralLetterPdfErrorType =
  (typeof GenerateReferralLetterPdfErrorType)[keyof typeof GenerateReferralLetterPdfErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateReferralLetterPdfErrorType = {
  NotFound: 'NotFound',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface GenerateTreatmentPlanPdfErrorResponse {
  type: GenerateTreatmentPlanPdfErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GenerateTreatmentPlanPdfErrorType =
  (typeof GenerateTreatmentPlanPdfErrorType)[keyof typeof GenerateTreatmentPlanPdfErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateTreatmentPlanPdfErrorType = {
  ValidationFailed: 'ValidationFailed',
  NotFound: 'NotFound',
} as const;

export interface GetAllergiesErrorResponse {
  type: GetAllergiesErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetAllergiesErrorType =
  (typeof GetAllergiesErrorType)[keyof typeof GetAllergiesErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAllergiesErrorType = {
  ValidationFailed: 'ValidationFailed',
} as const;

export interface GetAllergiesResponse {
  /** @nullable */
  allergies?: GetAllergiesResponseItem[] | null;
}

export interface GetAllergiesResponseItem {
  name: string;
  allergenId: string;
}

export interface GetAvailableStatesResponse {
  states: ReferenceState[];
}

export interface GetCurrentEncounterStatusErrorResponse {
  type: GetCurrentEncounterStatusErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetCurrentEncounterStatusErrorType =
  (typeof GetCurrentEncounterStatusErrorType)[keyof typeof GetCurrentEncounterStatusErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCurrentEncounterStatusErrorType = {
  InvalidNetwork: 'InvalidNetwork',
} as const;

export interface GetCurrentEncounterStatusResponse {
  dashboardStatus: DashboardStatus;
  /** @nullable */
  encounterId?: number | null;
  /** @nullable */
  encounterStatusId?: number | null;
  /** @nullable */
  stateName?: string | null;
  /** @nullable */
  showIdVerificationAnnouncementBanner?: boolean | null;
}

export interface GetEncounterErrorResponse {
  type: GetEncounterErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetEncounterErrorType =
  (typeof GetEncounterErrorType)[keyof typeof GetEncounterErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEncounterErrorType = {
  NotFound: 'NotFound',
} as const;

export interface GetEncounterPriceErrorResponse {
  type: GetEncounterPriceErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetEncounterPriceErrorType =
  (typeof GetEncounterPriceErrorType)[keyof typeof GetEncounterPriceErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEncounterPriceErrorType = {
  ValidationFailed: 'ValidationFailed',
  BadRequest: 'BadRequest',
} as const;

export interface GetEncounterPriceResponse {
  baseAmount: number;
  adjustment: number;
  adjustedAmount: number;
  /** @nullable */
  promoCode?: string | null;
  /** @nullable */
  hasVisitsWithinSevenDays?: boolean | null;
}

export interface GetEncounterResponse {
  encounter: EncounterResponse;
}

export interface GetEncounterWorkflowErrorResponse {
  type: GetEncounterWorkflowErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetEncounterWorkflowErrorType =
  (typeof GetEncounterWorkflowErrorType)[keyof typeof GetEncounterWorkflowErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEncounterWorkflowErrorType = {
  NotFound: 'NotFound',
} as const;

export interface GetEncountersResponse {
  encounters: EncounterSummaryItem[];
}

export interface GetFilesErrorResponse {
  type: GetFilesErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetFilesErrorType = (typeof GetFilesErrorType)[keyof typeof GetFilesErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFilesErrorType = {
  ValidationFailed: 'ValidationFailed',
  Forbidden: 'Forbidden',
} as const;

export interface GetFilesResponse {
  files: FileDTO[];
}

export interface GetInsuranceInfoForEncounterErrorResponse {
  type: GetInsuranceInfoForEncounterErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetInsuranceInfoForEncounterErrorType =
  (typeof GetInsuranceInfoForEncounterErrorType)[keyof typeof GetInsuranceInfoForEncounterErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetInsuranceInfoForEncounterErrorType = {
  NotFound: 'NotFound',
} as const;

/**
 * @nullable
 */
export type GetInsuranceInfoForEncounterResponseInsuranceEncounter = InsuranceEncounter | null;

export interface GetInsuranceInfoForEncounterResponse {
  /** @nullable */
  insuranceEncounter?: GetInsuranceInfoForEncounterResponseInsuranceEncounter;
}

export interface GetInsurancePlansErrorResponse {
  type: GetInsurancePlansErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetInsurancePlansErrorType =
  (typeof GetInsurancePlansErrorType)[keyof typeof GetInsurancePlansErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetInsurancePlansErrorType = {
  NotFound: 'NotFound',
} as const;

export interface GetInsurancePlansResponse {
  plans: InsurancePlan[];
}

export interface GetMedicalHistoryErrorResponse {
  type: GetMedicalHistoryErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetMedicalHistoryErrorType =
  (typeof GetMedicalHistoryErrorType)[keyof typeof GetMedicalHistoryErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMedicalHistoryErrorType = {
  NotFound: 'NotFound',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface GetMedicalIntakeErrorResponse {
  type: GetMedicalIntakeErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetMedicalIntakeErrorType =
  (typeof GetMedicalIntakeErrorType)[keyof typeof GetMedicalIntakeErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMedicalIntakeErrorType = {
  NotFound: 'NotFound',
  ValidationFailed: 'ValidationFailed',
} as const;

/**
 * @nullable
 */
export type GetMedicalIntakeResponseMedicalIntake = MedicalIntake | null;

export interface GetMedicalIntakeResponse {
  /** @nullable */
  medicalIntake?: GetMedicalIntakeResponseMedicalIntake;
}

export interface GetMedicationsErrorResponse {
  type: GetMedicationsErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetMedicationsErrorType =
  (typeof GetMedicationsErrorType)[keyof typeof GetMedicationsErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMedicationsErrorType = {
  ValidationFailed: 'ValidationFailed',
} as const;

export interface GetMedicationsResponse {
  /** @nullable */
  medications?: SelfReportedMedicationSearchResult[] | null;
}

export interface GetMessagesForEncounterErrorResponse {
  type: GetMessagesForEncounterErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetMessagesForEncounterErrorType =
  (typeof GetMessagesForEncounterErrorType)[keyof typeof GetMessagesForEncounterErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMessagesForEncounterErrorType = {
  NotFound: 'NotFound',
} as const;

export interface GetMessagesForEncounterResponse {
  messages: Message[];
  /** @nullable */
  activePeriodEndDate?: Date | null;
  canPatientMessage: boolean;
  isTriagedOut: boolean;
}

export interface GetNetworkConfigurationErrorResponse {
  type: GetNetworkConfigurationErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetNetworkConfigurationErrorType =
  (typeof GetNetworkConfigurationErrorType)[keyof typeof GetNetworkConfigurationErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNetworkConfigurationErrorType = {
  NotFound: 'NotFound',
} as const;

export interface GetNetworkConfigurationResponse {
  configuration: NetworkConfigurationDto;
}

export interface GetPaymentInfoErrorResponse {
  type: GetPaymentInfoErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetPaymentInfoErrorType =
  (typeof GetPaymentInfoErrorType)[keyof typeof GetPaymentInfoErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPaymentInfoErrorType = {
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
} as const;

export interface GetPaymentInfoResponse {
  /** @nullable */
  confirmationNumber?: string | null;
  baseAmount: number;
  /** @nullable */
  pricePaid?: number | null;
}

export interface GetPersonalInfoErrorResponse {
  type: GetPersonalInfoErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetPersonalInfoErrorType =
  (typeof GetPersonalInfoErrorType)[keyof typeof GetPersonalInfoErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPersonalInfoErrorType = {
  Forbidden: 'Forbidden',
  NotFound: 'NotFound',
  ValidationFailed: 'ValidationFailed',
} as const;

/**
 * @nullable
 */
export type GetPersonalInfoResponseGender = Gender | null;

/**
 * @nullable
 */
export type GetPersonalInfoResponseSurrogate = Surrogate | null;

/**
 * @nullable
 */
export type GetPersonalInfoResponsePendingExternalInfo = PendingExternalInfoResponse | null;

export interface GetPersonalInfoResponse {
  firstName: string;
  lastName: string;
  /** @nullable */
  middleName?: string | null;
  preferredTitle: PreferredTitle;
  /** @nullable */
  mailingAddress1?: string | null;
  /** @nullable */
  mailingAddress2?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  state?: string | null;
  /** @nullable */
  zip?: string | null;
  /** @nullable */
  username?: string | null;
  email: string;
  /** @nullable */
  homePhone?: string | null;
  /** @nullable */
  cellPhone?: string | null;
  /** @nullable */
  gender?: GetPersonalInfoResponseGender;
  /** @nullable */
  genderOther?: string | null;
  /** @nullable */
  dateOfBirth?: string | null;
  /** @nullable */
  marketingOptIn?: boolean | null;
  /** @nullable */
  textMe?: boolean | null;
  /** @nullable */
  surrogate?: GetPersonalInfoResponseSurrogate;
  hasExternalSurrogate: boolean;
  /** @nullable */
  pendingExternalInfo?: GetPersonalInfoResponsePendingExternalInfo;
  idvVerified: boolean;
  isMedicaid: boolean;
  /** @nullable */
  encounterState?: string | null;
  availableTfaMethods: AvailableTfaMethod[];
  preferredTfaMethod: TwoFactorMethod;
}

export interface GetPharmaciesErrorResponse {
  type: GetPharmaciesErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetPharmaciesErrorType =
  (typeof GetPharmaciesErrorType)[keyof typeof GetPharmaciesErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPharmaciesErrorType = {
  ValidationFailed: 'ValidationFailed',
  Forbidden: 'Forbidden',
} as const;

export interface GetPharmaciesResponse {
  pharmacies: PharmacyItem[];
  totalCount: number;
}

export interface GetPharmacyInfoErrorResponse {
  type: GetPharmacyInfoErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetPharmacyInfoErrorType =
  (typeof GetPharmacyInfoErrorType)[keyof typeof GetPharmacyInfoErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPharmacyInfoErrorType = {
  ValidationFailed: 'ValidationFailed',
  NotFound: 'NotFound',
} as const;

export interface GetPharmacyInfoResponse {
  pharmacy: PharmacyItem;
}

export interface GetPhotosErrorResponse {
  type: GetPhotosErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetPhotosErrorType = (typeof GetPhotosErrorType)[keyof typeof GetPhotosErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPhotosErrorType = {
  FetchFailed: 'FetchFailed',
} as const;

export interface GetPhotosResponse {
  files: ImageFileDto[];
}

export interface GetProviderInfoErrorResponse {
  type: GetProviderInfoErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetProviderInfoErrorType =
  (typeof GetProviderInfoErrorType)[keyof typeof GetProviderInfoErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProviderInfoErrorType = {
  NotFound: 'NotFound',
} as const;

export interface GetProviderInfoResponse {
  provider: GetProviderResponseItem;
}

/**
 * @nullable
 */
export type GetProviderResponseItemOfficeState = ProviderStateDto | null;

export interface GetProviderResponseItem {
  id: string;
  fullName: string;
  /** @nullable */
  gender?: string | null;
  /** @nullable */
  residencyTraining?: string | null;
  /** @nullable */
  medicalSchool?: string | null;
  isCertified: boolean;
  /** @nullable */
  graduationYear?: number | null;
  /** @nullable */
  officeState?: GetProviderResponseItemOfficeState;
  img: string;
  isAcceptingNewPatients: boolean;
  askNewPatientQuestion: boolean;
  /** @nullable */
  nextAvailableDate?: Date | null;
  isActive: boolean;
}

export interface GetProvidersErrorResponse {
  type: GetProvidersErrorType;
  message: string;
  /** @nullable */
  readonly errors?: readonly string[] | null;
}

export type GetProvidersErrorType =
  (typeof GetProvidersErrorType)[keyof typeof GetProvidersErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProvidersErrorType = {
  Forbidden: 'Forbidden',
  ValidationFailed: 'ValidationFailed',
  NotFound: 'NotFound',
} as const;

export interface GetProvidersResponse {
  providers: GetProviderResponseItem[];
  totalCount: number;
}

export interface GetQuestionsByPageErrorResponse {
  type: GetQuestionsByPageErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetQuestionsByPageErrorType =
  (typeof GetQuestionsByPageErrorType)[keyof typeof GetQuestionsByPageErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetQuestionsByPageErrorType = {
  NotFound: 'NotFound',
  InvalidQuestionConfiguration: 'InvalidQuestionConfiguration',
} as const;

export interface GetQuestionsByPageResponse {
  page: Page;
  /** @nullable */
  nextPageId?: number | null;
  /** @nullable */
  prevPageId?: number | null;
}

export type GetReferenceDataResponseVisitFlow = { [key: string]: number };

export interface GetReferenceDataResponse {
  states: ReferenceState[];
  providerSpecialInterests: ReferenceItem[];
  ethnicities: ReferenceItem[];
  genders: ReferenceItem[];
  visitFlow: GetReferenceDataResponseVisitFlow;
}

export interface GetReferredProviderErrorResponse {
  type: GetReferredProviderErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetReferredProviderErrorType =
  (typeof GetReferredProviderErrorType)[keyof typeof GetReferredProviderErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetReferredProviderErrorType = {
  ValidationFailed: 'ValidationFailed',
  NotFound: 'NotFound',
} as const;

export interface GetReferredProviderResponse {
  /** @nullable */
  referredProviderId?: string | null;
}

export interface GetRegisterExternalPatientSeedResponse {
  hasEmail: boolean;
}

export interface GetSurrogateInfoErrorResponse {
  type: GetSurrogateInfoErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetSurrogateInfoErrorType =
  (typeof GetSurrogateInfoErrorType)[keyof typeof GetSurrogateInfoErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSurrogateInfoErrorType = {
  Forbidden: 'Forbidden',
  NotFound: 'NotFound',
  ValidationFailed: 'ValidationFailed',
} as const;

/**
 * @nullable
 */
export type GetSurrogateInfoResponseSurrogate = Surrogate | null;

export interface GetSurrogateInfoResponse {
  /** @nullable */
  surrogate?: GetSurrogateInfoResponseSurrogate;
}

export interface GetTreatmentPlanErrorResponse {
  type: GetTreatmentPlanErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetTreatmentPlanErrorType =
  (typeof GetTreatmentPlanErrorType)[keyof typeof GetTreatmentPlanErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTreatmentPlanErrorType = {
  NotFound: 'NotFound',
} as const;

/**
 * @nullable
 */
export type GetTreatmentPlanResponseAssignedProvider = ProviderInfo | null;

/**
 * @nullable
 */
export type GetTreatmentPlanResponseApprovedProvider = ProviderInfo | null;

/**
 * @nullable
 */
export type GetTreatmentPlanResponseAboutYourDiagnosis = DiagnosisModel | null;

/**
 * @nullable
 */
export type GetTreatmentPlanResponseCounseling = CounselingModel | null;

export interface GetTreatmentPlanResponse {
  encounterId: number;
  networkName: string;
  canMessage: boolean;
  unreadMessages: number;
  hasMessages: boolean;
  /** @nullable */
  assignedProvider?: GetTreatmentPlanResponseAssignedProvider;
  /** @nullable */
  approvedProvider?: GetTreatmentPlanResponseApprovedProvider;
  encounterResolution: EncounterResolution;
  treatmentPlanUnread: boolean;
  /** @nullable */
  diagnosisDate?: Date | null;
  /** @nullable */
  createDate?: Date | null;
  /** @nullable */
  lastStatusDate?: Date | null;
  /** @nullable */
  diagnosisName?: string | null;
  /** @nullable */
  diagnosisIcd10Code?: string | null;
  prescriptions: PrescriptionModel[];
  otcProducts: OtcProductModel[];
  otcProductsAds: OtcProductAdModel[];
  ads: MarketingAdInfo[];
  /** @nullable */
  messageFromProvider?: string | null;
  /** @nullable */
  followUpVisitDate?: Date | null;
  /** @nullable */
  referralTextHtml?: string | null;
  /** @nullable */
  triageOutMessage?: string | null;
  hasReferralSpecialist: boolean;
  /** @nullable */
  aboutYourDiagnosis?: GetTreatmentPlanResponseAboutYourDiagnosis;
  /** @nullable */
  treatmentDetails?: string | null;
  /** @nullable */
  counseling?: GetTreatmentPlanResponseCounseling;
  additionalAdvices: string[];
}

export interface GetVQResponsesErrorResponse {
  type: GetVQResponsesErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetVQResponsesErrorType =
  (typeof GetVQResponsesErrorType)[keyof typeof GetVQResponsesErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetVQResponsesErrorType = {
  NotFound: 'NotFound',
} as const;

export interface GetVQResponsesResponse {
  variableResponses: VariableResponse[];
}

export interface GetVerificationErrorsErrorResponse {
  type: GetVerificationErrorsErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetVerificationErrorsErrorType =
  (typeof GetVerificationErrorsErrorType)[keyof typeof GetVerificationErrorsErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetVerificationErrorsErrorType = {
  NotFound: 'NotFound',
  ValidationFailed: 'ValidationFailed',
} as const;

/**
 * @nullable
 */
export type GetVerificationErrorsResponseBirthDateMismatch = BirthDateMismatch | null;

export interface GetVerificationErrorsResponse {
  /** @nullable */
  errors?: VouchedError[] | null;
  /** @nullable */
  birthDateMismatch?: GetVerificationErrorsResponseBirthDateMismatch;
}

export interface GetVerificationInfoErrorResponse {
  type: GetVerificationInfoErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetVerificationInfoErrorType =
  (typeof GetVerificationInfoErrorType)[keyof typeof GetVerificationInfoErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetVerificationInfoErrorType = {
  NotFound: 'NotFound',
  ValidationFailed: 'ValidationFailed',
} as const;

/**
 * @nullable
 */
export type GetVerificationInfoResponseManualReviewStatus = IdentityVerificationStatus | null;

export interface GetVerificationInfoResponse {
  /** @nullable */
  jobId?: string | null;
  type: IdentityVerificationType;
  currentRetries: number;
  /** @nullable */
  manualReviewStatus?: GetVerificationInfoResponseManualReviewStatus;
}

export interface GetZipFromCoordinatesErrorResponse {
  type: GetZipFromCoordinatesErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type GetZipFromCoordinatesErrorType =
  (typeof GetZipFromCoordinatesErrorType)[keyof typeof GetZipFromCoordinatesErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetZipFromCoordinatesErrorType = {
  ValidationFailed: 'ValidationFailed',
  ReverseGeocodingFailed: 'ReverseGeocodingFailed',
  ZipCodeNotFound: 'ZipCodeNotFound',
  ZipNotInUS: 'ZipNotInUS',
  ApiFailed: 'ApiFailed',
} as const;

export interface GetZipFromCoordinatesResponse {
  zipCode: string;
}

export type GrantType = (typeof GrantType)[keyof typeof GrantType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GrantType = {
  client_credentials: 'client_credentials',
} as const;

export interface HostedPciConfiguration {
  /** @nullable */
  location?: string | null;
  /** @nullable */
  siteId?: string | null;
  /** @nullable */
  reportCCType?: string | null;
  /** @nullable */
  reportCCDigits?: string | null;
  /** @nullable */
  reportCVVDigits?: string | null;
}

export interface IdentityFields {
  /** @nullable */
  firstName?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @nullable */
  birthday?: Date | null;
}

export type IdentityVerificationStatus =
  (typeof IdentityVerificationStatus)[keyof typeof IdentityVerificationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IdentityVerificationStatus = {
  Approved: 'Approved',
  Rejected: 'Rejected',
  ManualReview: 'ManualReview',
  ManuallyRejected: 'ManuallyRejected',
  ManuallyApproved: 'ManuallyApproved',
} as const;

export type IdentityVerificationType =
  (typeof IdentityVerificationType)[keyof typeof IdentityVerificationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IdentityVerificationType = {
  Idv: 'Idv',
  SelfieVerification: 'SelfieVerification',
  Reverify: 'Reverify',
} as const;

/**
 * @nullable
 */
export type IllnessModelType = IllnessType | null;

export interface IllnessModel {
  observationKey: string;
  /** @nullable */
  type?: IllnessModelType;
  /** @nullable */
  name?: string | null;
}

export type IllnessType = (typeof IllnessType)[keyof typeof IllnessType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IllnessType = {
  Current: 'Current',
  Chronic: 'Chronic',
  Recurrent: 'Recurrent',
  Past: 'Past',
} as const;

export interface Image {
  id: number;
  source: string;
}

/**
 * @nullable
 */
export type ImageFileDtoBodyLocation = BodyLocationType | null;

/**
 * @nullable
 */
export type ImageFileDtoReasonType = FileReasonType | null;

export interface ImageFileDto {
  id: number;
  path: string;
  type: string;
  status: FileStatus;
  hash: string;
  /** @nullable */
  bodyLocation?: ImageFileDtoBodyLocation;
  description: string;
  /** @nullable */
  reasonType?: ImageFileDtoReasonType;
  /** @nullable */
  otherReason?: string | null;
  imageSrc: string;
}

export type ImageSize = (typeof ImageSize)[keyof typeof ImageSize];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImageSize = {
  Full: 'Full',
  Small: 'Small',
  Thumb: 'Thumb',
} as const;

/**
 * @nullable
 */
export type ImportConvergePatientModelAddress = ConvergeAddress | null;

/**
 * @nullable
 */
export type ImportConvergePatientModelPhone = ConvergePhone | null;

/**
 * @nullable
 */
export type ImportConvergePatientModelCareGiver = ConvergeCareGiver | null;

export interface ImportConvergePatientModel {
  patient_id: string;
  /** @minLength 1 */
  client_id: string;
  first_name: string;
  last_name: string;
  email: string;
  /** @nullable */
  address?: ImportConvergePatientModelAddress;
  /** @nullable */
  phone?: ImportConvergePatientModelPhone;
  /** @nullable */
  birth_date?: string | null;
  /** @nullable */
  gender?: string | null;
  /** @nullable */
  gender_identity?: string | null;
  /** @nullable */
  program_id?: string | null;
  /** @nullable */
  member_id?: string | null;
  /** @nullable */
  careGiverId?: string | null;
  /** @nullable */
  careGiver?: ImportConvergePatientModelCareGiver;
}

export interface InsuranceEncounter {
  insuranceRelationId: string;
  /** @nullable */
  insuranceRelation?: string | null;
  /** @nullable */
  insurancePlanId?: string | null;
  /** @nullable */
  insurancePlanName?: string | null;
  insuranceId: string;
  /** @nullable */
  insuredFirstName?: string | null;
  /** @nullable */
  insuredLastName?: string | null;
  /** @nullable */
  insuredBirthday?: string | null;
  insuredSameAddress: boolean;
  /** @nullable */
  insuredPrimaryAddr1?: string | null;
  /** @nullable */
  insuredPrimaryAddr2?: string | null;
  /** @nullable */
  insuredPrimaryCity?: string | null;
  /** @nullable */
  insuredPrimaryState?: string | null;
  /** @nullable */
  insuredPrimaryZip?: string | null;
}

export interface InsurancePlan {
  insurancePlanId: string;
  description: string;
}

export interface InsuranceRelationResponse {
  id: string;
  title: string;
  usePatientAsSubscriber: boolean;
}

export type LifeFactor = (typeof LifeFactor)[keyof typeof LifeFactor];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LifeFactor = {
  alcohol: 'alcohol',
  tobacco: 'tobacco',
  sun: 'sun',
  tanning: 'tanning',
} as const;

export interface LoginErrorResponse {
  type: LoginErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
  /** @nullable */
  remainingAttempts?: number | null;
}

export type LoginErrorType = (typeof LoginErrorType)[keyof typeof LoginErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoginErrorType = {
  InvalidCredentials: 'InvalidCredentials',
  MigrationFailed: 'MigrationFailed',
  ServerError: 'ServerError',
  InvalidUsername: 'InvalidUsername',
  AccountLocked: 'AccountLocked',
  MissingEmail: 'MissingEmail',
} as const;

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginSuccessResponse {
  token: string;
  userId: string;
  twoFactorMethod: TwoFactorMethod;
  target: string;
  availableTfaMethods: TwoFactorMethod[];
}

export interface MarkTreatmentPlanAsReadErrorResponse {
  type: MarkTreatmentPlanAsReadErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type MarkTreatmentPlanAsReadErrorType =
  (typeof MarkTreatmentPlanAsReadErrorType)[keyof typeof MarkTreatmentPlanAsReadErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarkTreatmentPlanAsReadErrorType = {
  Forbidden: 'Forbidden',
  NotUnread: 'NotUnread',
} as const;

export interface Marketing {
  treatmentPlan: MarketingPage;
  dashboard: MarketingPage;
  login: MarketingPage;
  accountCreation: MarketingPage;
  preScreen: MarketingPage;
  aboutYourCondition: MarketingPage;
}

export interface MarketingAdInfo {
  imageLocation: string;
  /** @nullable */
  imageLink?: string | null;
  /** @nullable */
  imageData?: string | null;
}

export interface MarketingContent {
  /** @nullable */
  desktop?: string | null;
  /** @nullable */
  mobile?: string | null;
}

/**
 * @nullable
 */
export type MarketingPageTop = MarketingContent | null;

/**
 * @nullable
 */
export type MarketingPageBottom = MarketingContent | null;

export interface MarketingPage {
  /** @nullable */
  top?: MarketingPageTop;
  /** @nullable */
  bottom?: MarketingPageBottom;
}

export interface MedicalHistory {
  allergies: AllergyModel[];
  medications: MedicationModel[];
  surgeries: string[];
  illnesses: IllnessModel[];
  familyDiseases: string[];
}

/**
 * @nullable
 */
export type MedicalIntakeSkinTone = SkinTone | null;

/**
 * @nullable
 */
export type MedicalIntakeEthnicity = Ethnicity | null;

/**
 * @nullable
 */
export type MedicalIntakeAlcoholConsumption = AlcoholConsumption | null;

/**
 * @nullable
 */
export type MedicalIntakeTobaccoConsumption = TobaccoConsumption | null;

/**
 * @nullable
 */
export type MedicalIntakeSunbathFrequency = Frequencies | null;

/**
 * @nullable
 */
export type MedicalIntakeTimeOutdoorsFrequency = Frequencies | null;

/**
 * @nullable
 */
export type MedicalIntakeFemaleQuestion = FemaleQuestion | null;

export interface MedicalIntake {
  skinType: SkinTypeLegacy;
  /** @nullable */
  skinTone?: MedicalIntakeSkinTone;
  /** @nullable */
  ethnicity?: MedicalIntakeEthnicity;
  heightFeet: number;
  heightInches: number;
  weight: number;
  /** @nullable */
  alcoholConsumption?: MedicalIntakeAlcoholConsumption;
  /** @nullable */
  tobaccoConsumption?: MedicalIntakeTobaccoConsumption;
  /** @nullable */
  sunbathFrequency?: MedicalIntakeSunbathFrequency;
  /** @nullable */
  timeOutdoorsFrequency?: MedicalIntakeTimeOutdoorsFrequency;
  /** @nullable */
  occupation?: string | null;
  /** @nullable */
  lifeFactors?: LifeFactor[] | null;
  visitGender: Gender;
  /** @nullable */
  visitGenderOther?: string | null;
  uterus: boolean;
  /** @nullable */
  femaleQuestion?: MedicalIntakeFemaleQuestion;
  /** @nullable */
  dueDate?: string | null;
  /** @nullable */
  employmentStatus?: string | null;
}

export interface MedicationModel {
  observationKey: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  doseSpotMedicationId?: number | null;
  /** @nullable */
  doseSpotSelfReportedMedId?: number | null;
}

export interface Message {
  messageId: number;
  /** @nullable */
  messageText?: string | null;
  senderId: string;
  messageDate: Date;
  isRead: boolean;
  images: Image[];
  fileNames: string[];
}

/**
 * @nullable
 */
export type NetworkConfigurationDtoHostedPciConfiguration = HostedPciConfiguration | null;

export interface NetworkConfigurationDto {
  networkId: number;
  insuranceActive: boolean;
  displayInsuranceAttestation: boolean;
  displayMarketingNotificationsBanner: boolean;
  /** @nullable */
  appTitle?: string | null;
  readonlyProfile: boolean;
  createAccountEnabled: boolean;
  createExternalPatientEnabled: boolean;
  /** @nullable */
  networkInsuranceCarrierId?: string | null;
  identityVerificationActive: boolean;
  aboutUsUrl: string;
  termsOfUseUrl: string;
  privacyPolicyUrl: string;
  /** @nullable */
  privacyPolicySummary?: string | null;
  /** @nullable */
  termsOfUseSummary?: string | null;
  useHostedPciPayment: boolean;
  /** @nullable */
  hostedPciConfiguration?: NetworkConfigurationDtoHostedPciConfiguration;
  loginPageDisabled: boolean;
  /** @nullable */
  logoutUrl?: string | null;
  /** @nullable */
  logoutText?: string | null;
  marketing: Marketing;
  /** @nullable */
  humanizationTheme?: string | null;
  externalLoginOptions: ExternalLoginOption[];
  promoCodeEnabled: boolean;
  showMarketingOptIn: boolean;
  /** @nullable */
  paymentSuccessCreditCardInfo?: string | null;
  displayOncePerWeekInsuranceDisclaimer: boolean;
  usePatientIdNumberLabel: boolean;
  /** @nullable */
  welcomeMessage?: string | null;
  /** @nullable */
  logoUrl?: string | null;
  /** @nullable */
  logoAltText?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  pharmacySelectionDescription?: string | null;
  medicaidFlowEnabled: boolean;
}

export interface OtcProductAdModel {
  adLink: string;
  adLocation: string;
  /** @nullable */
  adImageData?: string | null;
}

export interface OtcProductModel {
  otcProductName: string;
  otcInstructions: string;
  /** @nullable */
  imageLink?: string | null;
  /** @nullable */
  imageData?: string | null;
}

export interface Page {
  title: string;
  reviewTitle: string;
  /** @nullable */
  subtitle?: string | null;
  pageId: number;
  questions: Question[];
}

export interface PasswordResetErrorResponse {
  type: TokenValidationStatus;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export interface PasswordResetRequest {
  token: string;
  /**
   * @minLength 8
   * @maxLength 100
   */
  password: string;
}

export interface PasswordResetResponse {
  success: boolean;
}

export type PatientRelationships = (typeof PatientRelationships)[keyof typeof PatientRelationships];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientRelationships = {
  Mother: 'Mother',
  Father: 'Father',
  Aunt: 'Aunt',
  Uncle: 'Uncle',
  Spouse: 'Spouse',
  Son: 'Son',
  Daughter: 'Daughter',
  Grandparent: 'Grandparent',
  Guardian: 'Guardian',
  Other: 'Other',
} as const;

export type PaymentErrorCodes = (typeof PaymentErrorCodes)[keyof typeof PaymentErrorCodes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentErrorCodes = {
  Declined: 'Declined',
  CallAuthCenter: 'CallAuthCenter',
  PickupCard: 'PickupCard',
  ExpiredCard: 'ExpiredCard',
  IncorrectPin: 'IncorrectPin',
  InvalidCard: 'InvalidCard',
  ServiceNotAllowed: 'ServiceNotAllowed',
  ExceedsLimit: 'ExceedsLimit',
  GenericError: 'GenericError',
  CVVDeclined: 'CVVDeclined',
  AVSDeclined: 'AVSDeclined',
} as const;

/**
 * @nullable
 */
export type PendingExternalInfoResponsePatient = IdentityFields | null;

/**
 * @nullable
 */
export type PendingExternalInfoResponseSurrogate = IdentityFields | null;

export interface PendingExternalInfoResponse {
  /** @nullable */
  patient?: PendingExternalInfoResponsePatient;
  /** @nullable */
  surrogate?: PendingExternalInfoResponseSurrogate;
}

export interface PersonalInfoErrorResponse {
  type: PersonalInfoErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type PersonalInfoErrorType =
  (typeof PersonalInfoErrorType)[keyof typeof PersonalInfoErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersonalInfoErrorType = {
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface PersonalInfoRequest {
  firstName: string;
  preferredTitle: PreferredTitle;
  lastName: string;
  mailingAddress1: string;
  /** @nullable */
  mailingAddress2?: string | null;
  city: string;
  state: string;
  /** @pattern ^\d{5}$ */
  zip: string;
  email: string;
  /** @nullable */
  homePhone?: string | null;
  cellPhone: string;
  gender: Gender;
  /** @nullable */
  genderOther?: string | null;
  dateOfBirth: string;
  /** @nullable */
  textMe?: boolean | null;
}

export interface PersonalInfoResponse {
  message: string;
}

export type PharmaciesSort = (typeof PharmaciesSort)[keyof typeof PharmaciesSort];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PharmaciesSort = {
  Distance: 'Distance',
  NameAsc: 'NameAsc',
  NameDesc: 'NameDesc',
} as const;

export interface PharmacyItem {
  id: number;
  name: string;
  address1: string;
  /** @nullable */
  address2?: string | null;
  phone: string;
  fax: string;
  city: string;
  state: string;
  zip: string;
  hasMailOrder: boolean;
  /** @nullable */
  distance?: number | null;
}

export interface PharmacyOverrideErrorResponse {
  type: PharmacyOverrideErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type PharmacyOverrideErrorType =
  (typeof PharmacyOverrideErrorType)[keyof typeof PharmacyOverrideErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PharmacyOverrideErrorType = {
  ValidationFailed: 'ValidationFailed',
  NotFound: 'NotFound',
} as const;

export interface PharmacyOverrideResponse {
  /** @nullable */
  overrideMessageHtml?: string | null;
  /** @nullable */
  pharmacySearchString?: string | null;
}

export type PharmacyType = (typeof PharmacyType)[keyof typeof PharmacyType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PharmacyType = {
  MailOrder: 'MailOrder',
  Retail: 'Retail',
} as const;

export type PreferredTitle = (typeof PreferredTitle)[keyof typeof PreferredTitle];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreferredTitle = {
  mr: 'mr',
  mrs: 'mrs',
  miss: 'miss',
  ms: 'ms',
  none: 'none',
} as const;

export interface PrescriptionModel {
  dateAdded: Date;
  drugName: string;
  /** @nullable */
  drugForm?: string | null;
  /** @nullable */
  sig?: string | null;
  /** @nullable */
  duration?: string | null;
  /** @nullable */
  strength?: string | null;
  /** @nullable */
  quantity?: string | null;
  /** @nullable */
  refills?: string | null;
  /** @nullable */
  pharmacyName?: string | null;
  /** @nullable */
  pharmacyAddress?: string | null;
  /** @nullable */
  pharmacyPhone?: string | null;
  /** @nullable */
  pharmacyHasMailOrder?: boolean | null;
}

export interface ProviderInfo {
  name: string;
  /** @nullable */
  img: string | null;
}

export interface ProviderStateDto {
  abbreviation: string;
  name: string;
  timeZone: string;
}

export interface Question {
  questionId: number;
  text: string;
  /** @nullable */
  subText?: string | null;
  /** @nullable */
  otherText?: string | null;
  /** @nullable */
  placeholderText?: string | null;
  answerType: AnswerType;
  /** @nullable */
  maxLength?: number | null;
  rank: number;
  isRequired: boolean;
  answers: QuestionAnswer[];
  /** @nullable */
  triggeredByAnswerChoiceId?: number | null;
}

export interface QuestionAnswer {
  answerId: number;
  text: string;
}

export type QuestionMultipleResponseType =
  (typeof QuestionMultipleResponseType)[keyof typeof QuestionMultipleResponseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionMultipleResponseType = {
  Multiple: 'Multiple',
} as const;

export interface QuestionMultipleResponse {
  questionId: number;
  /** @nullable */
  responseOther?: string | null;
  /** @nullable */
  response?: string[] | null;
  type: QuestionMultipleResponseType;
}

export type QuestionResponse = QuestionSingeResponse | QuestionMultipleResponse;

export type QuestionSingeResponseType =
  (typeof QuestionSingeResponseType)[keyof typeof QuestionSingeResponseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionSingeResponseType = {
  Single: 'Single',
} as const;

export interface QuestionSingeResponse {
  questionId: number;
  /** @nullable */
  responseOther?: string | null;
  /** @nullable */
  response?: string | null;
  type: QuestionSingeResponseType;
}

export interface ReferenceItem {
  key: string;
  value: string;
}

export interface ReferenceState {
  abbreviation: string;
  name: string;
}

export interface RegisterErrorResponse {
  type: RegisterErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type RegisterErrorType = (typeof RegisterErrorType)[keyof typeof RegisterErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterErrorType = {
  UserAlreadyExists: 'UserAlreadyExists',
  UserCreationFailed: 'UserCreationFailed',
  ValidationFailed: 'ValidationFailed',
  InvalidUsername: 'InvalidUsername',
} as const;

export type RegisterExternalPatientCredentialsOnlyRequestType =
  (typeof RegisterExternalPatientCredentialsOnlyRequestType)[keyof typeof RegisterExternalPatientCredentialsOnlyRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterExternalPatientCredentialsOnlyRequestType = {
  credentialsOnly: 'credentialsOnly',
} as const;

export interface RegisterExternalPatientCredentialsOnlyRequest {
  /**
   * @minLength 0
   * @maxLength 100
   */
  username: string;
  /**
   * @minLength 8
   * @maxLength 100
   */
  password: string;
  networkId: number;
  seedKey: string;
  type: RegisterExternalPatientCredentialsOnlyRequestType;
}

export interface RegisterExternalPatientErrorResponse {
  type: RegisterExternalPatientErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type RegisterExternalPatientErrorType =
  (typeof RegisterExternalPatientErrorType)[keyof typeof RegisterExternalPatientErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterExternalPatientErrorType = {
  UserAlreadyExists: 'UserAlreadyExists',
  UserCreationFailed: 'UserCreationFailed',
  ValidationFailed: 'ValidationFailed',
  PayloadMissing: 'PayloadMissing',
  PayloadAlreadyUsed: 'PayloadAlreadyUsed',
} as const;

export type RegisterExternalPatientRequest =
  | RegisterExternalPatientCredentialsOnlyRequest
  | RegisterExternalPatientWithEmailRequest;

export type RegisterExternalPatientWithEmailRequestType =
  (typeof RegisterExternalPatientWithEmailRequestType)[keyof typeof RegisterExternalPatientWithEmailRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterExternalPatientWithEmailRequestType = {
  credentialsWithEmail: 'credentialsWithEmail',
} as const;

export interface RegisterExternalPatientWithEmailRequest {
  /**
   * @minLength 0
   * @maxLength 100
   */
  username: string;
  /**
   * @minLength 8
   * @maxLength 100
   */
  password: string;
  networkId: number;
  seedKey: string;
  email: string;
  type: RegisterExternalPatientWithEmailRequestType;
}

export interface RegisterRequest {
  /**
   * @minLength 0
   * @maxLength 100
   */
  username: string;
  /**
   * @minLength 8
   * @maxLength 100
   */
  password: string;
  networkId: number;
  email: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  firstName: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  lastName: string;
  marketingOptIn: boolean;
}

export interface RegisterSuccessResponse {
  token: string;
  userId: string;
  twoFactorMethod: TwoFactorMethod;
  availableTfaMethods: TwoFactorMethod[];
  target: string;
}

export interface ReplaceEncounterPhotosErrorResponse {
  type: ReplaceEncounterPhotosErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type ReplaceEncounterPhotosErrorType =
  (typeof ReplaceEncounterPhotosErrorType)[keyof typeof ReplaceEncounterPhotosErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReplaceEncounterPhotosErrorType = {
  ValidationFailed: 'ValidationFailed',
  Forbidden: 'Forbidden',
  HasBadPhotos: 'HasBadPhotos',
} as const;

export interface ReplaceImageErrorResponse {
  type: ReplaceImageErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type ReplaceImageErrorType =
  (typeof ReplaceImageErrorType)[keyof typeof ReplaceImageErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReplaceImageErrorType = {
  ValidationFailed: 'ValidationFailed',
  InvalidImage: 'InvalidImage',
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
} as const;

export type RequestCodeErrorResponse = ServerErrorResponse | ValidationErrorResponse;

export interface RequestCodeRequest {
  method: TwoFactorMethod;
}

export interface RequestCodeSuccessResponse {
  method: TwoFactorMethod;
  destination: string;
}

export interface RestoreUsernamesErrorResponse {
  type: RestoreUsernamesErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type RestoreUsernamesErrorType =
  (typeof RestoreUsernamesErrorType)[keyof typeof RestoreUsernamesErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RestoreUsernamesErrorType = {
  ValidationFailed: 'ValidationFailed',
  NetworkNotFound: 'NetworkNotFound',
} as const;

export interface RestoreUsernamesRequest {
  email: string;
  networkId: number;
}

export interface ResubmitEncounterErrorResponse {
  type: ResubmitEncounterErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type ResubmitEncounterErrorType =
  (typeof ResubmitEncounterErrorType)[keyof typeof ResubmitEncounterErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResubmitEncounterErrorType = {
  ValidationFailed: 'ValidationFailed',
  Forbidden: 'Forbidden',
} as const;

export interface ResubmitEncounterResponse {
  visitStatus: number;
}

export interface SaveEmailForMarketingRequest {
  email: string;
}

export interface SaveEmailForMarketingResponse {
  marketingEmail: string;
}

export interface SaveInsuranceErrorResponse {
  type: SaveInsuranceErrorType;
  message: string;
  /** @nullable */
  errors?: Error[] | null;
  /** @nullable */
  basePrice?: number | null;
}

export type SaveInsuranceErrorType =
  (typeof SaveInsuranceErrorType)[keyof typeof SaveInsuranceErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SaveInsuranceErrorType = {
  ValidationFailed: 'ValidationFailed',
  EncounterNotFound: 'EncounterNotFound',
  Forbidden: 'Forbidden',
  InvalidInsurance: 'InvalidInsurance',
  SubscriberDoesNotMatchPatient: 'SubscriberDoesNotMatchPatient',
} as const;

export interface SaveInsuranceRequest {
  insuranceCarrierId: string;
  /** @nullable */
  insurancePlanId?: string | null;
  insuredRelationshipId: string;
  insuranceId: string;
  subscriberFirstName: string;
  subscriberLastName: string;
  subscriberBirthday: string;
  /** @nullable */
  groupNumber?: string | null;
  /** @nullable */
  otherInsuranceName?: string | null;
  readonly subscriberAddressSameAsPatient: boolean;
}

export interface SaveInsuranceResponse {
  /** @nullable */
  responseMessage?: string | null;
  calculatedPrice: number;
  maximumPrice: number;
  insuranceCoverage: number;
  /** @nullable */
  insurancePaymentMethod?: string | null;
  /** @nullable */
  isInsuranceActive?: boolean | null;
  hasVisitsWithinSevenDays: boolean;
  isGovernmentProgram: boolean;
  requiresPcpSpecialistReferral: boolean;
  nonParticipatingPlan: boolean;
}

export interface SelfReportedMedicationSearchResult {
  nameWithRouteDoseForm: string;
  doseSpotId: number;
}

export type ServerErrorResponseType =
  (typeof ServerErrorResponseType)[keyof typeof ServerErrorResponseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServerErrorResponseType = {
  ServerError: 'ServerError',
} as const;

export interface ServerErrorResponse {
  message: string;
  type: ServerErrorResponseType;
}

export interface SetPreferredTfaMethodErrorResponse {
  type: SetPreferredTfaMethodErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type SetPreferredTfaMethodErrorType =
  (typeof SetPreferredTfaMethodErrorType)[keyof typeof SetPreferredTfaMethodErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetPreferredTfaMethodErrorType = {
  ValidationFailed: 'ValidationFailed',
  Unauthorized: 'Unauthorized',
  MethodNotAvailable: 'MethodNotAvailable',
  UpdateFailed: 'UpdateFailed',
} as const;

export interface SetPreferredTfaMethodRequest {
  method: TwoFactorMethod;
}

export type SkinTone = (typeof SkinTone)[keyof typeof SkinTone];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SkinTone = {
  veryLight: 'veryLight',
  light: 'light',
  medium: 'medium',
  lightBrown: 'lightBrown',
  darkBrown: 'darkBrown',
  veryDark: 'veryDark',
} as const;

export type SkinType = (typeof SkinType)[keyof typeof SkinType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SkinType = {
  normal: 'normal',
  oily: 'oily',
  dry: 'dry',
  combination: 'combination',
} as const;

export type SkinTypeLegacy = (typeof SkinTypeLegacy)[keyof typeof SkinTypeLegacy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SkinTypeLegacy = {
  normal: 'normal',
  oily: 'oily',
  dry: 'dry',
  combination: 'combination',
  sensitive: 'sensitive',
} as const;

export type SortByNameDirection = (typeof SortByNameDirection)[keyof typeof SortByNameDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortByNameDirection = {
  None: 'None',
  Desc: 'Desc',
  Asc: 'Asc',
} as const;

export interface SsoLoginErrorResponse {
  type: SsoLoginErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
  /** @nullable */
  network?: string | null;
}

export type SsoLoginErrorType = (typeof SsoLoginErrorType)[keyof typeof SsoLoginErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SsoLoginErrorType = {
  InvalidRequest: 'InvalidRequest',
  InvalidSsoToken: 'InvalidSsoToken',
  MigrationFailed: 'MigrationFailed',
  UserCreationFailed: 'UserCreationFailed',
} as const;

export interface SsoLoginRequest {
  sso: SsoType;
  token: string;
  /** @nullable */
  seedKey?: string | null;
}

export interface SsoLoginSuccessResponse {
  token: string;
  userId: string;
  email: string;
  network: string;
}

export type SsoType = (typeof SsoType)[keyof typeof SsoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SsoType = {
  Mdlive: 'Mdlive',
  Converge: 'Converge',
} as const;

export interface StateRuleDto {
  ruleId: number;
}

export interface SupportIssueResponse {
  id: SupportIssueType;
  description: string;
}

export type SupportIssueType = (typeof SupportIssueType)[keyof typeof SupportIssueType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportIssueType = {
  TreatmentPlanQuestion: 'TreatmentPlanQuestion',
  Other: 'Other',
  PaymentHelp: 'PaymentHelp',
  UnableToCompleteVisit: 'UnableToCompleteVisit',
  VisitCancellation: 'VisitCancellation',
  TechnicalIssues: 'TechnicalIssues',
  ManualIdentityVerification: 'ManualIdentityVerification',
  IdentityVerification: 'IdentityVerification',
  PrescriptionQuestion: 'PrescriptionQuestion',
} as const;

export interface Surrogate {
  relationshipToPatient: PatientRelationships;
  email: string;
  phone: string;
  /** @nullable */
  textMe?: boolean | null;
  firstName: string;
  /** @nullable */
  middleName?: string | null;
  preferredTitle: PreferredTitle;
  lastName: string;
  address1: string;
  /** @nullable */
  address2?: string | null;
  city: string;
  state: string;
  /** @pattern ^\d{5}$ */
  zip: string;
  birthday: string;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  verified?: boolean | null;
}

export interface TextVQResponse {
  /** @nullable */
  readonly single?: string | null;
  /** @nullable */
  readonly multiple?: readonly string[] | null;
}

export type TobaccoConsumption = (typeof TobaccoConsumption)[keyof typeof TobaccoConsumption];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TobaccoConsumption = {
  never: 'never',
  occasional: 'occasional',
  frequently: 'frequently',
  daily: 'daily',
} as const;

export type TokenValidationStatus =
  (typeof TokenValidationStatus)[keyof typeof TokenValidationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TokenValidationStatus = {
  Valid: 'Valid',
  Expired: 'Expired',
  Invalid: 'Invalid',
} as const;

export type TwoFactorMethod = (typeof TwoFactorMethod)[keyof typeof TwoFactorMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TwoFactorMethod = {
  Phone: 'Phone',
  Email: 'Email',
} as const;

export interface UpdateAvatarErrorResponse {
  type: UpdateAvatarErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdateAvatarErrorType =
  (typeof UpdateAvatarErrorType)[keyof typeof UpdateAvatarErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateAvatarErrorType = {
  ValidationFailed: 'ValidationFailed',
  Forbidden: 'Forbidden',
  NotFound: 'NotFound',
  InvalidImage: 'InvalidImage',
} as const;

export interface UpdateEncounterBirthdayErrorResponse {
  type: UpdateEncounterBirthdayErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdateEncounterBirthdayErrorType =
  (typeof UpdateEncounterBirthdayErrorType)[keyof typeof UpdateEncounterBirthdayErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateEncounterBirthdayErrorType = {
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  ValidationFailed: 'ValidationFailed',
  InvalidVisitStatus: 'InvalidVisitStatus',
} as const;

export interface UpdateEncounterMessagesToReadErrorResponse {
  type: UpdateEncounterMessagesToReadErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdateEncounterMessagesToReadErrorType =
  (typeof UpdateEncounterMessagesToReadErrorType)[keyof typeof UpdateEncounterMessagesToReadErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateEncounterMessagesToReadErrorType = {
  ValidationFailed: 'ValidationFailed',
  NotFound: 'NotFound',
} as const;

export interface UpdateEncounterMessagesToReadRequest {
  messageIds: number[];
}

export interface UpdateEncounterStatusErrorResponse {
  type: UpdateEncounterStatusErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdateEncounterStatusErrorType =
  (typeof UpdateEncounterStatusErrorType)[keyof typeof UpdateEncounterStatusErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateEncounterStatusErrorType = {
  Forbidden: 'Forbidden',
  ValidationFailed: 'ValidationFailed',
  InvalidTransition: 'InvalidTransition',
} as const;

export interface UpdateEncounterStatusRequest {
  statusId: number;
}

export interface UpdateEncounterStatusResponse {
  visitStatus: number;
}

export interface UpdateExternalInfoErrorResponse {
  type: UpdateExternalInfoErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdateExternalInfoErrorType =
  (typeof UpdateExternalInfoErrorType)[keyof typeof UpdateExternalInfoErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateExternalInfoErrorType = {
  Forbidden: 'Forbidden',
  NotFound: 'NotFound',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface UpdateImageErrorResponse {
  type: UpdateImageErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdateImageErrorType = (typeof UpdateImageErrorType)[keyof typeof UpdateImageErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateImageErrorType = {
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface UpdateImageRequest {
  bodyLocation: BodyLocationType;
  /** @nullable */
  description?: string | null;
}

export interface UpdateImageResponse {
  imageId: number;
}

export interface UpdateMedicalHistoryErrorResponse {
  type: UpdateMedicalHistoryErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdateMedicalHistoryErrorType =
  (typeof UpdateMedicalHistoryErrorType)[keyof typeof UpdateMedicalHistoryErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateMedicalHistoryErrorType = {
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface UpdateMedicalHistoryRequest {
  medications: CreateMedicationParams[];
  allergies: CreateAllergyParams[];
  surgeries: string[];
  illnesses: CreateIllnessParams[];
  familyDiseases: string[];
  incomplete: boolean;
}

export interface UpdateMedicalHistoryResponse {
  visitStatus: number;
}

export interface UpdateMedicalIntakeErrorResponse {
  type: UpdateMedicalIntakeErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdateMedicalIntakeErrorType =
  (typeof UpdateMedicalIntakeErrorType)[keyof typeof UpdateMedicalIntakeErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateMedicalIntakeErrorType = {
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface UpdateMedicalIntakeRequest {
  medicalIntake: CreateMedicalIntake;
  incomplete: boolean;
}

export interface UpdateMedicalIntakeResponse {
  visitStatus: number;
}

export interface UpdatePersonalNotificationsErrorResponse {
  type: UpdatePersonalNotificationsErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdatePersonalNotificationsErrorType =
  (typeof UpdatePersonalNotificationsErrorType)[keyof typeof UpdatePersonalNotificationsErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdatePersonalNotificationsErrorType = {
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface UpdatePersonalNotificationsRequest {
  textMe: boolean;
}

export interface UpdatePreferredPharmacyErrorResponse {
  type: UpdatePreferredPharmacyErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdatePreferredPharmacyErrorType =
  (typeof UpdatePreferredPharmacyErrorType)[keyof typeof UpdatePreferredPharmacyErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdatePreferredPharmacyErrorType = {
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface UpdatePreferredPharmacyRequest {
  doseSpotPharmacyId: number;
  doseSpotPharmacyName: string;
}

export interface UpdatePreferredPharmacyResponse {
  visitStatus: number;
}

export interface UpdatePreferredPharmacyTypeErrorResponse {
  type: UpdatePreferredPharmacyTypeErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdatePreferredPharmacyTypeErrorType =
  (typeof UpdatePreferredPharmacyTypeErrorType)[keyof typeof UpdatePreferredPharmacyTypeErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdatePreferredPharmacyTypeErrorType = {
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface UpdatePreferredPharmacyTypeRequest {
  pharmacyType: PharmacyType;
}

export interface UpdatePreferredPharmacyTypeResponse {
  pharmacyType: PharmacyType;
}

export interface UpdatePreferredProviderErrorResponse {
  type: UpdatePreferredProviderErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdatePreferredProviderErrorType =
  (typeof UpdatePreferredProviderErrorType)[keyof typeof UpdatePreferredProviderErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdatePreferredProviderErrorType = {
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface UpdatePreferredProviderRequest {
  /** @nullable */
  preferredProviderId: string | null;
  /** @nullable */
  hasSeenProvider?: boolean | null;
}

export interface UpdatePreferredProviderResponse {
  visitStatus: number;
  videoRequired: boolean;
}

export interface UpdateSmsTfaOptionErrorResponse {
  type: UpdateSmsTfaOptionErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdateSmsTfaOptionErrorType =
  (typeof UpdateSmsTfaOptionErrorType)[keyof typeof UpdateSmsTfaOptionErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSmsTfaOptionErrorType = {
  ValidationFailed: 'ValidationFailed',
  Unauthorized: 'Unauthorized',
  NotConfigured: 'NotConfigured',
  InvalidPhoneNumber: 'InvalidPhoneNumber',
  UpdateFailed: 'UpdateFailed',
} as const;

export interface UpdateSmsTfaOptionRequest {
  phoneNumber: string;
}

export interface UpdateSmsTfaOptionResponse {
  phoneNumber: string;
}

export interface UpdateSurrogateInfoErrorResponse {
  type: UpdateSurrogateInfoErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdateSurrogateInfoErrorType =
  (typeof UpdateSurrogateInfoErrorType)[keyof typeof UpdateSurrogateInfoErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSurrogateInfoErrorType = {
  Forbidden: 'Forbidden',
  NotFound: 'NotFound',
  ValidationFailed: 'ValidationFailed',
} as const;

/**
 * @nullable
 */
export type UpdateSurrogateInfoRequestSurrogate = Surrogate | null;

export interface UpdateSurrogateInfoRequest {
  /** @nullable */
  surrogate?: UpdateSurrogateInfoRequestSurrogate;
  /** @nullable */
  textPatient?: boolean | null;
}

/**
 * @nullable
 */
export type UpdateSurrogateInfoResponseSurrogate = Surrogate | null;

export interface UpdateSurrogateInfoResponse {
  /** @nullable */
  surrogate?: UpdateSurrogateInfoResponseSurrogate;
}

export interface UpdateSurrogateNotificationsErrorResponse {
  type: UpdateSurrogateNotificationsErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdateSurrogateNotificationsErrorType =
  (typeof UpdateSurrogateNotificationsErrorType)[keyof typeof UpdateSurrogateNotificationsErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSurrogateNotificationsErrorType = {
  Forbidden: 'Forbidden',
  NotFound: 'NotFound',
  ValidationFailed: 'ValidationFailed',
} as const;

export interface UpdateSurrogateNotificationsRequest {
  textMe: boolean;
}

export interface UpdateVQResponsesErrorResponse {
  type: UpdateVQResponsesErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export type UpdateVQResponsesErrorType =
  (typeof UpdateVQResponsesErrorType)[keyof typeof UpdateVQResponsesErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateVQResponsesErrorType = {
  ValidationFailed: 'ValidationFailed',
  NotFound: 'NotFound',
  Forbidden: 'Forbidden',
  BadRequest: 'BadRequest',
} as const;

export interface UpdateVQResponsesRequest {
  answers: QuestionResponse[];
  incomplete: boolean;
}

export interface UpdateVQResponsesResponse {
  visitStatus: number;
}

export type ValidationErrorResponseType =
  (typeof ValidationErrorResponseType)[keyof typeof ValidationErrorResponseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ValidationErrorResponseType = {
  ValidationError: 'ValidationError',
} as const;

export interface ValidationErrorResponse {
  message: string;
  /** @nullable */
  errors?: string[] | null;
  type: ValidationErrorResponseType;
}

export interface VariableResponse {
  questionId: number;
  reviewTitle: string;
  pageId: number;
  /** @nullable */
  triggeredByAnswerChoiceId?: number | null;
  response: string;
  /** @nullable */
  responseOther?: string | null;
  /** @nullable */
  labelText?: string | null;
  answerType: AnswerType;
  textResponses: TextVQResponse;
}

export interface VerifyCodeErrorResponse {
  type: VerifyCodeErrorType;
  message: string;
  /** @nullable */
  errors?: string[] | null;
  /** @nullable */
  remainingAttempts?: number | null;
}

export type VerifyCodeErrorType = (typeof VerifyCodeErrorType)[keyof typeof VerifyCodeErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VerifyCodeErrorType = {
  InvalidCode: 'InvalidCode',
  TwoFactorNotEnabled: 'TwoFactorNotEnabled',
  Unauthorized: 'Unauthorized',
  AccountLocked: 'AccountLocked',
} as const;

export interface VerifyCodeRequest {
  code: string;
}

export interface VerifyCodeSuccessResponse {
  token: string;
  userId: string;
  email: string;
}

export interface VerifyResetTokenErrorResponse {
  type: TokenValidationStatus;
  message: string;
  /** @nullable */
  errors?: string[] | null;
}

export interface VerifyResetTokenRequest {
  token: string;
}

export interface VerifyResetTokenResponse {
  success: boolean;
}

/**
 * @nullable
 */
export type VouchedErrorTypeProperty = VouchedErrorType | null;

export interface VouchedError {
  /** @nullable */
  type?: VouchedErrorTypeProperty;
}

export type VouchedErrorType = (typeof VouchedErrorType)[keyof typeof VouchedErrorType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VouchedErrorType = {
  FaceMatchError: 'FaceMatchError',
  IdFaceMatchError: 'IdFaceMatchError',
  NameMatchError: 'NameMatchError',
  BarcodeMatchError: 'BarcodeMatchError',
  BirthDateMatchError: 'BirthDateMatchError',
  ExpiredIdError: 'ExpiredIdError',
  InvalidIdPhotoError: 'InvalidIdPhotoError',
  UnsupportedIdPhotoError: 'UnsupportedIdPhotoError',
  InvalidUserPhotoError: 'InvalidUserPhotoError',
  InvalidIdError: 'InvalidIdError',
} as const;

export interface WorkflowResponse {
  workflowId: number;
  label: string;
  pages: EncounterWorkflowPage[];
}

export type CreateOauthTokenBody = {
  client_id: string;
  client_secret: string;
  grant_type: GrantType;
};

export type GetEncountersParams = {
  status?: EncounterStatus;
};

export type CreateEncountersFilesBody = {
  file: Blob;
};

export type CreateEncountersImagesBody = {
  file: Blob;
  bodyLocation?: BodyLocationType;
  description?: string;
};

export type CreateEncountersMessagesBody = {
  messageText?: string;
  files?: Blob[];
};

export type ReplaceEncountersImagesBody = {
  file: Blob;
  bodyLocation?: BodyLocationType;
  description?: string;
};

export type GetAllergiesParams = {
  searchTerm?: string;
  max?: number;
};

export type GetEncountersAvailableStatesParams = {
  networkId?: number;
};

export type GetCancellationReasonsParams = {
  networkId?: number;
};

export type GetEncountersCurrentStatusParams = {
  networkId?: number;
};

export type GetIssueTypesParams = {
  networkId?: number;
};

export type GetMedicationsParams = {
  searchTerm?: string;
  max?: number;
};

export type GetNetworksConfigurationParams = {
  encounterId?: number;
};

export type GetPatientAvatarParams = {
  size?: ImageSize;
};

export type GetPharmaciesParams = {
  name?: string;
  zip?: string;
  specialty?: PharmacyType;
  sort?: PharmaciesSort;
  latitude?: number;
  longitude?: number;
  page?: number;
  pageSize?: number;
};

export type GetPharmaciesOverrideParams = {
  encounterId?: number;
  sessionId?: string;
};

export type GetEncountersPhotosParams = {
  width?: number;
  height?: number;
  includeBad?: boolean;
};

export type GetProviderImageParams = {
  size?: ImageSize;
};

export type GetProviderParams = {
  encounterId?: number;
};

export type GetProvidersParams = {
  encounterId?: number;
  sort?: SortByNameDirection;
  genders?: Gender[];
  timezones?: string[];
};

export type GetEncountersQuestionsParams = {
  pageId?: number;
};

export type GetReferredProviderParams = {
  referralId?: number;
};

export type GetZipCodesParams = {
  /**
   * @minimum -90
   * @maximum 90
   */
  lat?: number;
  /**
   * @minimum -180
   * @maximum 180
   */
  lng?: number;
};

export type RegisterExternalPatientBodyOne =
  | RegisterExternalPatientCredentialsOnlyRequest
  | RegisterExternalPatientWithEmailRequest;

export type RegisterExternalPatientBodyTwo =
  | RegisterExternalPatientCredentialsOnlyRequest
  | RegisterExternalPatientWithEmailRequest;

export type RegisterExternalPatientBodyThree =
  | RegisterExternalPatientCredentialsOnlyRequest
  | RegisterExternalPatientWithEmailRequest;

export type CreateSessionBodyOne = { [key: string]: string };

export type CreateSessionBodyTwo = { [key: string]: string };

export type CreateSessionBodyThree = { [key: string]: string };

export type CreatePatientAvatarBody = {
  avatar: Blob;
};
